import React from 'react';
import { useTranslation } from 'react-i18next';
import BzmIcon from '../../../components/icons/BzmIcon';
import styles from './BlueprintsHero.module.css';

interface Props {
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const BlueprintsHero = ({ searchTerm, onSearchChange }: Props) => {
  const { t } = useTranslation('blueprints');
  return (
    <div className={styles.hero}>
      <h2 className={styles.title}>{t('hero.title')}</h2>
      <p className={styles.subtitle}>{t('hero.subtitle')}</p>
      <div className={styles.searchWrap}>
        <BzmIcon variant="icon-bzm-search" size={16} className={styles.searchIcon} />
        <input
          data-test="bp-search"
          className={styles.search}
          placeholder={t('hero.searchPlaceholder')}
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default BlueprintsHero;
